import axios from "./axios";

class Routes {
  async login(data) {
    const response = await axios.post(`/login`, data);
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async forgotPassword(data) {
    const response = await axios.post(`/forgotPassword`, data);
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async verifyEmail(data) {
    const response = await axios.post(`/verifyEmail`, data);
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async resetPassword(data) {
    const response = await axios.post(`/resetPassword`, data);
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async getImage(link) {
    const response = await axios.get(`/getImage`, {
      params: { link },
    });
  
    if (response && response.response?.data) return response.response.data;
    return response.data;
  } 
}

export default new Routes();
